module.exports = __webpack_public_path__ + "img/Nacken_farbig.c3ff1ac.svg";